// extracted by mini-css-extract-plugin
export default {"container":"MyWork_container__cqDSp"};